export enum SOEOperations {
  ASSIGN,
  TRANSFER,
}
